/*
 * Suggestions du panier lateral.
 *
 * Le tiroir est re-rendu en entier a chaque ajout ou changement de quantite
 * (cart-drawer.js, cart.js) : l element est donc recree a chaque fois, et
 * connectedCallback relance le chargement. Le cache par contenu de panier
 * evite de refaire la requete — et le clignotement — quand rien n a change.
 */
if (!customElements.get('lpf-suggestions')) {
  const cache = new Map();

  const charger = async (url, produit, intent) => {
    const reponse = await fetch(
      `${url}?section_id=lpf-panier-suggestions&product_id=${produit}&limit=10&intent=${intent}`
    );
    if (!reponse.ok) return null;
    const piste = new DOMParser()
      .parseFromString(await reponse.text(), 'text/html')
      .querySelector('.lpf-suggestions__piste');
    return piste && Number(piste.dataset.total) > 0 ? piste.innerHTML : null;
  };

  customElements.define(
    'lpf-suggestions',
    class LpfSuggestions extends HTMLElement {
      connectedCallback() {
        this.piste = this.querySelector('.lpf-suggestions__piste');
        this.addEventListener('click', this.onClick.bind(this));
        this.remplir();
      }

      async remplir() {
        const { url, produit, cle } = this.dataset;
        if (!url || !produit) return;

        if (!cache.has(cle)) {
          // Search & Discovery d abord, l algorithme de Shopify en repli.
          cache.set(
            cle,
            charger(url, produit, 'complementary')
              .then((html) => html || charger(url, produit, 'related'))
              .catch(() => null)
          );
        }

        const html = await cache.get(cle);
        if (!html || !this.isConnected) return;
        this.piste.innerHTML = html;
        this.hidden = false;
        this.majFleches();
        this.piste.addEventListener('scroll', () => this.majFleches(), { passive: true });
      }

      majFleches() {
        const { scrollLeft, scrollWidth, clientWidth } = this.piste;
        const prec = this.querySelector('[data-lpf-defile="-1"]');
        const suiv = this.querySelector('[data-lpf-defile="1"]');
        if (prec) prec.disabled = scrollLeft <= 2;
        if (suiv) suiv.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
        this.toggleAttribute('data-defile', scrollWidth > clientWidth + 2);
      }

      onClick(event) {
        const fleche = event.target.closest('[data-lpf-defile]');
        if (fleche) {
          this.piste.scrollBy({ left: Number(fleche.dataset.lpfDefile) * this.piste.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }

        const ajout = event.target.closest('[data-lpf-ajout]');
        if (ajout) this.ajouter(ajout);
      }

      async ajouter(bouton) {
        bouton.disabled = true;
        bouton.setAttribute('aria-busy', 'true');

        try {
          // Defini par lpf-ajout-rapide.js, charge dans theme.liquid.
          await window.lpfAjouterAuPanier(bouton.dataset.lpfAjout);
        } catch (erreur) {
          bouton.disabled = false;
          bouton.removeAttribute('aria-busy');
          console.error(erreur);
        }
      }
    }
  );
}
